<script>
import range from 'lodash/range';
import { getYear } from 'date-fns';
import dayOptions from '@/lib/dayOptions';
import {hasEditPermission, currentRoleLevelName} from '@/mixins/roleLevelPermissions';
import { mapState } from 'vuex';

export default {
	props: ['agreementData'],
	data() {
		const year = getYear(new Date());

		return {
			dayOptions,
			yearOptions: range(year, year + 5),
			isViewMode : !hasEditPermission('section-spousal-support'),
			showLearnButton: ['client-level-1', 'client-level-2'].includes(currentRoleLevelName)
		};
	},
	computed: {
		...mapState(['currentRoleLevel']),
		spousalSupport() {
			if(this.agreementData.properties?.length == 1 && this.agreementData.properties[0].address)
			this.agreementData.spousalSupport.payableFromWhichProperty = this.agreementData.properties[0].address['street']
			return this.agreementData.spousalSupport;
			// return this.agreementData.spousalSupport =  this.agreementData.spousalSupport.hasOwnProperty('additionalClausesToRecitals') 
			// 	? this.agreementData.spousalSupport 
			// 	: {...this.agreementData.spousalSupport, additionalClausesToRecitals: []};
		},
		childSupport() {
			return this.agreementData.childSupport;
		},
		hasFamilyResidence() {
			return this.agreementData.agreement.propertyRecitals.includes(
				'Family Residence'
			);
		},
		lumpsumSpousalSupportPaymentOptions() {
			let paymentOptions = [];
			const propertyRecitals = (section) =>
				this.agreementData.agreement.propertyRecitals &&
				this.agreementData.agreement.propertyRecitals.length &&
				this.agreementData.agreement.propertyRecitals.includes(section);
			// if (propertyRecitals('Family Residence')) {
			// 	paymentOptions = [
			// 		...paymentOptions,
			// 		{
			// 			text: 'Paid as part of the transfer or sale of the Family Residence',
			// 			value: 'familyResidence',
			// 		},
			// 	];
			// }
			// if (propertyRecitals('Additional Real Property')) {
			// 	paymentOptions = [
			// 		...paymentOptions,
			// 		{
			// 			text: 'Paid as part of the transfer or sale of Additional Real Property',
			// 			value: 'additionalProperty',
			// 		},
			// 	];
			// }
			if (propertyRecitals('Family Residence') || propertyRecitals('Additional Real Property')) {
				paymentOptions = [
					...paymentOptions,
					{
						text: 'Factored into the Equalization Payment',
						value: 'factoredInEqPayment',
					},
				];
			}

			return [
				...paymentOptions,
				{ text: 'Paid when the Agreement is signed', value: 'signed' },
			];
		},
		additionalPropertyChoices() {
			return this.agreementData.properties.map((property, index) => (
					{
						text:  this.getAddressText(property.address),
						value: `${property.address['street']}`,
					}
			));
		},
		isUserSeparatingParty(){
			return this.currentRoleLevel.roleAssociated === 'party'
		},
		dynamicQuestions(){
			if(this.isUserSeparatingParty){
				return {
					payor: "Who will pay the Spousal Support?"

				}
			}
			else{
				return {
					payor: "Which party will pay the Spousal Support?"

				}
			}
		}
	},
	methods:{
		getAddressText(address){
			 let formattedAddress = '';
			 formattedAddress = address['street'] ? `${address['street']},` : '';
			 formattedAddress += address['city'] ? `${address['city']},` : '';
			 formattedAddress += address['province'] ? `${address['province']}` : '';
			 return formattedAddress;
		}
	},
	mounted(){
		this.agreementData.spousalSupport =  this.agreementData.spousalSupport.hasOwnProperty('additionalClausesToRecitals') 
			? this.agreementData.spousalSupport 
			: {...this.agreementData.spousalSupport, additionalClausesToRecitals: []};
	},
	watch: {
		'spousalSupport.endPoint': function(newVal) {
			if (newVal === 'Indefinitely' && !this.spousalSupport.endingCircumstances.includes('Indefinitely')) {
				this.spousalSupport.endingCircumstances = ['Indefinitely'];
			} else if (newVal !== 'Indefinitely' && this.spousalSupport.endingCircumstances.includes('Indefinitely')) {
				this.spousalSupport.endingCircumstances = this.spousalSupport.endingCircumstances.filter(circumstance => circumstance !== 'Indefinitely');
			}
		}
	}
};
</script>

<template>
	<b-card>
		<div slot="header" class="section-heading">
			<h4>Spousal Support Details</h4>
			<a href="#" onclick="Intercom('showArticle', 11079751)" v-if="this.showLearnButton">Learn &nbsp;<b-icon-book/></a>
		</div>

		<radio-group
			v-model="spousalSupport.paymentType"
			select
			reset-undefined
			input-cols="8"
			label="Is Spousal Support going to be paid or waived?"
			:options="[
				{ value: 'periodic', text: 'Paid periodically' },
				{ value: 'lump-sum', text: 'Paid in lump sum' },
				{
					value: 'waiver',
					text: 'No spousal support payable, waiving all future support',
				},
				{
					value: 'no-spousal-no-waiver',
					text: 'No spousal support currently payable, but the right to spousal support has not been waived',
				},
			]"
			:testid="'spousal-support-paid-or-waived'"
			:length="'long'"
			:disabled="isViewMode"
			toolTipText="Spousal Support is typically a periodic payment, paid monthly.  However, it may also be calculated as a Lump Sum
			that can be added or subtracted from other amounts owing from property distribution.  Each of you may also waive your
			right to support meaning that neither of you will claim support from one another now or in the future. Lastly, there
			may be a case where there is an entitlement to Spousal Support but the calculation shows that there is not currently enough money to pay any amount."
		/>

		<conditional-group
			class="mt-2"
			:condition="spousalSupport.paymentType === 'periodic'"
		>
			<radio-group
				v-model="spousalSupport.payor"
				:agreement-data="agreementData"
				input-cols="4"
				:label="dynamicQuestions.payor"
				partner
				reset-undefined
				select
				:testid="'spousal-support-payor'"
				:length="'long'"
				:disabled="isViewMode"
			/>

			<radio-group
				v-model="spousalSupport.commencementTrigger"
				class="mt-2"
				select
				input-cols="11"
				reset-undefined
				label="When will Spousal Support commence?"
				:options="[
					{
						value: 'agreement',
						text: 'On a specified day, immediately following the Agreement being signed',
					},
					{
						value: 'house',
						text: 'On a specified day, immediately following the selling of the house',
					},
					{ value: 'date', text: 'On a particular date' },
				]"
				:testid="'spousal-support-commencement'"
				:length="'long'"
				:disabled="isViewMode"
				toolTipText="Typically, Spousal Support is paid on the first day of the month immediately following the Agrement
				being signed and will continue on the first of each month thereafter.  If you decided to reside together for a
				period and share household expenses, you can opt to have it payable after the transfer of the Family Residence.
				Or if you rent and you know that you'll be moving out on a particular date, you can specify a particular date after that."
			/>

			<conditional-group
				class="mt-2"
				:condition="spousalSupport.commencementTrigger === 'agreement'"
			>
				<radio-group
					v-model="spousalSupport.commencementDay"
					:options="dayOptions"
					input-cols="2"
					label="On which day of the month?"
					reset-undefined
					select
					:testid="'spousal-support-month'"
					:disabled="isViewMode"
				/>
			</conditional-group>

			<conditional-group
				class="mt-2"
				:condition="spousalSupport.commencementTrigger === 'house'"
			>
				<radio-group
					v-model="spousalSupport.commencementDay"
					:options="dayOptions"
					input-cols="2"
					label="Day"
					reset-undefined
					select
					:testid="'spousal-support-commencement-day'"
					:disabled="isViewMode"
				/>
			</conditional-group>

			<conditional-group
				class="mt-2"
				:condition="spousalSupport.commencementTrigger === 'date'"
			>
				<date-input
					v-model="spousalSupport.commencementDate"
					input-cols="4"
					reset-undefined
					label="Date"
					:testid="'spousal-support-commencement-date'"
					:disabled="isViewMode"
				/>
			</conditional-group>

			<input-group
				v-model="spousalSupport.periodicPayment"
				class="mt-2"
				reset-undefined
				label="What is the monthly amount of Spousal Support?"
				dollar
				:testid="'spousal-support-periodic-payment'"
				:disabled="isViewMode"
				toolTipText="Enter the amount to be paid per month."
			/>

			<radio-group
				v-model="spousalSupport.paymentFrequency"
				class="mt-2"
				input-cols="4"
				select
				label="Spousal Support will be paid in:"
				reset-undefined
				:options="[
					{ value: 'one-payment', text: 'One payment' },
					{ value: 'two-payments', text: 'Two payments' },
					{ value: 'bi-weekly-payments', text: 'Bi-weekly payments' },
				]"
				:testid="'spousal-support-payment-frequency'"
				:length="'long'"
				:disabled="isViewMode"
				toolTipText="Typically, Spousal Support is paid in one monthly payment, but sometimes,
				people prefer to be more specific and follow their bi-weekly paycheques or paid twice monthly."
			/>

			<conditional-group
				class="mt-2"
				:condition="spousalSupport.paymentFrequency === 'one-payment'"
			>
				<radio-group
					v-model="spousalSupport.firstPaymentDay"
					:options="dayOptions"
					input-cols="2"
					label="What day of each month will Spousal Support continue to be paid?"
					reset-undefined
					select
					:testid="'spousal-support-first-payment-day'"
					:disabled="isViewMode"
				/>
			</conditional-group>

			<conditional-group
				class="mt-2"
				:condition="spousalSupport.paymentFrequency === 'two-payments'"
			>
				<radio-group
					v-model="spousalSupport.firstPaymentDay"
					class="mb-2"
					:options="dayOptions"
					input-cols="2"
					label="On what day of the month will the first Spousal Support payment continue to be paid?"
					reset-undefined
					select
					:testid="'spousal-support-first-payment-month'"
					:disabled="isViewMode"
				/>

				<radio-group
					v-model="spousalSupport.secondPaymentDay"
					:options="dayOptions"
					input-cols="2"
					label="On what day of the month will the second Spousal Support payment continue to be paid?"
					reset-undefined
					select
					:testid="'spousal-support-second-payment-month'"
					:disabled="isViewMode"
				/>
			</conditional-group>


			<radio-group
				v-model="spousalSupport.endPoint"
				:agreement-data="agreementData"
				input-cols="4"
				label="Is spousal support paid indefinitely or with a specified end point?"
				:options="['Indefinitely','specified end point']"
				reset-undefined
				:testid="'spousal-support-end-point'"
				class="mt-2"
				:disabled="isViewMode"
				toolTipText="Your calculation will tell you if the duration is indefinite or if there is a limited duration.
				Indefinite support means that the duration is undefined and subject to variation and review.
				A specified end point means that you'll agree to pay spousal support for a period of time, for example payable
				until a specific date, or until a specific time, like retirement."
			/>

			<conditional-group
				class="mt-2"
				:condition="spousalSupport.endPoint === 'specified end point'"
			>
				<conditional-check-group
					v-model="spousalSupport.endingCircumstances"
					class="mt-3"
					input-cols="10"
					label="Spousal Support will be payable until"
					reset-undefined
					select
					:options="[
						{ value: 'A specific Date' },
						{ value: 'The payor retires' },
						{ value: 'The recipient retires' },
						{ value: 'The payor dies' },
						{ value: 'The recipient dies' },
						{ value: 'The recipient begins living in a marriage-like relationship' },
						{ value: 'The recipient becomes self-supporting' }
					]"
					:testid="'spousal-support-payable-options-'"
					:id="'spousal-support-payable-options-'"
					:disabled="isViewMode"
				>
					<template slot="A specific Date">
						<date-input
							v-model="spousalSupport.endDate"
							label="Date"
							reset-undefined
							:testid="'spousal-support-end-date'"
							:disabled="isViewMode"
						/>
					</template>
				</conditional-check-group>
			</conditional-group>

			<yes-no-choice
				v-model="spousalSupport.reviewable"
				reset-undefined
				label="Is Spousal Support subject to review and variation?"
				class="mt-2"
				:testid="'spousal-support-reviewable'"
				:disabled="isViewMode"
				toolTipText="While Child Support must be reviewed annually under the law, Spousal Support doesn't have to be.
				An indefinite duration of Spousal Support is usually subject to review and variation, but your amount can also
				be a final amount for a finite amount of time."
			/>

			<conditional-group
				:condition="
					(!childSupport.reviewable && spousalSupport.reviewable) ||
					(spousalSupport.reviewable &&
						!agreementData.agreement.sections.includes(
							'Child Support'
						))
				"
			>
				<radio-group
					v-model="spousalSupport.reviewYear"
					reset-undefined
					class="mt-3"
					input-cols="4"
					select
					label="In what year will review commence?"
					:options="yearOptions"
					:testid="'spousal-support-review-year'"
					:disabled="isViewMode"
				/>
			</conditional-group>
		</conditional-group>

		<conditional-group
			class="mt-2"
			:condition="spousalSupport.paymentType === 'lump-sum'"
		>
			<radio-group
				v-model="spousalSupport.payor"
				:agreement-data="agreementData"
				input-cols="4"
				:label="dynamicQuestions.payor"
				partner
				reset-undefined
				select
				:testid="'spousal-support-payor'"
				:length="'long'"
				:disabled="isViewMode"
			/>

			<input-group
				v-model="spousalSupport.lumpSumPayment"
				class="mt-2"
				reset-undefined
				label="What is the lump sum spousal payment?"
				dollar
				:testid="'spousal-support-lump-sum-payment'"
				:disabled="isViewMode"
				toolTipText="You can calculate a lump sum amount based on the Spousal Support amount, net of tax,
				for a particular amount of months.  You can calculate this amount online or with the assistance of your lawyer."
			/>

			<!-- <conditional-group class="mt-2" :condition="hasFamilyResidence">
				<yes-no-choice
					v-model="spousalSupport.payableFromFamilyResidenceProceeds"
					reset-undefined
					label="Is the Lump Sum Spousal payable out of the payor's share of the proceeds of the Family Residence?"
					class="mt-2"
					:testid="'spousal-support-payable-from-family-residence-proceeds'"
					:disabled="isViewMode"
				/>
			</conditional-group> -->
			<radio-group
				v-model="spousalSupport.payableFromFamilyResidenceProceedsOrProperty"
				class="mb-2"
				input-cols="10"
				label="How will the lump Sum Spousal Support be paid?"
				reset-undefined
				select
				:options="lumpsumSpousalSupportPaymentOptions"
				:testid="'lumpsum-spousal-support-payment-options'"
				toolTipText="You can factor this payment into the Equalization Payment, so that it is added/subtracted to other
				amounts owing from Property Distribution, or you may have it paid as a stand-alone payment when the agreement
				is signed.  If you have other payments due to Property Distribution, it is most common to Factor it into the
				Equalization Payment."
				:disabled="isViewMode"
			/>
			<!-- <conditional-group
				class="my-3"
				:condition="spousalSupport.payableFromFamilyResidenceProceedsOrProperty === 'additionalProperty' && 
				additionalPropertyChoices.length>1"
			>
				<b-form-group
					id="input-additionalPropertySelection"
					input-cols="8"
					label="Select the additional property you would like to use"
					label-for="additionalPropertySelection"
				>
					<b-form-select
						id="additionalPropertySelection"
						v-model="spousalSupport.payableFromWhichProperty"
						size="sm"
						:options="additionalPropertyChoices"
						data-testid="additional-property-spousal-support"
					/>
				</b-form-group>
			</conditional-group> -->
		</conditional-group>
		<additional-clauses :title="'Additional Clauses into Recitals'" :newLabel="'Add Clause to Recitals'" class="mt-2" v-model="spousalSupport.additionalClausesToRecitals" :testid="'spousal-support-add-clause-to-recitals-'"
		:disabled="isViewMode"/>
		<additional-clauses :title="'Additional Clauses into Sections'" :newLabel="'Add Clause to Section'" class="mt-2" v-model="spousalSupport.additionalClauses" :testid="'spousal-support-add-clause-'"
		:disabled="isViewMode"/>
	</b-card>
</template>
